import type { ReactNode } from 'react';

import matchUrl from '../../string/matchUrl';

const replaceWithAnchor = (text: string, pattern: string, index: number) => {
    const components = text.split(pattern);
    // if there are no matches
    if (components.length === 1) {
        return text;
    }

    const result = [];

    // empty value in first position means string starts with pattern
    if (components[0] !== '') {
        result.push(components[0]);
    }

    components.shift();

    // empty value in last position means string ends with pattern
    if (components[components.length - 1] === '') {
        components.pop();
    }

    result.push(
        <a key={pattern + index} href={pattern} target="_blank" rel="noreferrer noopener">
            {pattern}
        </a>,
    );
    result.push(components.join(pattern));

    return result.filter((item) => item !== '');
};
const matchUrlsAndReplace = (text: string) => {
    const matchedUrls = matchUrl(text);

    if (!matchedUrls?.length) {
        return text;
    }

    return matchedUrls.reduce<string | ReactNode[]>((accumulator, pattern, index) => {
        if (typeof accumulator === 'string') {
            return replaceWithAnchor(accumulator, pattern, index);
        }

        return accumulator.flatMap((item) => {
            if (typeof item === 'string') {
                return replaceWithAnchor(item, pattern, index);
            }

            return item;
        });
    }, text);
};

const makeUrlClickable = (text: string | ReactNode[]) => {
    if (typeof text === 'string') {
        return matchUrlsAndReplace(text);
    }

    return text.flatMap((item) => {
        if (typeof item === 'string') {
            return matchUrlsAndReplace(item);
        }

        return item;
    }, text);
};

export default makeUrlClickable;
